import React from 'react'
import Img from "../../Assets/Images/cashbox_double_1.1.png"
function Podxod() {
  return (
    <section className='py-20 preview'>
      <div className='container px-5 mx-auto flex flex-col lg:flex-row items-center justify-center space-y-10 lg:space-y-0 lg:space-x-20'>
        <div data-aos="flip-down" className='max-w-[452px] mx-auto lg:mx-0'>
          <h2 className='text-[30px] sm:text-[40px] font-bold text-white mb-2'>КОМПЛЕКСНЫЙ ПОДХОД</h2>
          <p className='text-white text-[13px] mb-5 sm:text-[18px]'>CASHBOX - Контрольно-кассовая машина, Банковский терминал, функции обычного смартфона
            ANDROID - Кассовый софт, банковский софт, складской учёт
            UZOFD - Интеграция с налоговыми органами</p>
        </div>
        <img data-aos="zoom-in-up" className='w-[421px] h-[450px] sm:h-[543px]' src={Img} width={421} height={543} alt='Img ' />
      </div>
    </section>
  )
}

export default Podxod